import { call, put } from "redux-saga/effects";
import apiChat from "../../services/apiChat";

import MessagesActions from "../ducks/messages";

export function* getMessages({ id_from, id_to, customer_key, limit }) {
  try {
    const response = yield call(
      apiChat.get,
      `message?id_from=${id_from}&&id_to=${id_to}&&customer_key=${customer_key}&&limit=${limit}`
    );

    yield put(MessagesActions.getMessagesSuccess(response.data));
    yield put(
      MessagesActions.getPendingMessages(id_from, id_from, customer_key)
    );
  } catch (err) {
    // TODO
  }
}

export function* postMessages({ data }) {
  try {
    yield call(apiChat.post, "message", data);
  } catch (err) {
    // TODO
  }
}

export function* refreshMessages({ id_from, id_to, customer_key }) {
  try {
    const response = yield call(
      apiChat.get,
      `refresh?id_from=${id_from}&&id_to=${id_to}&&customer_key=${customer_key}`
    );

    yield put(MessagesActions.getMessagesSuccess(response.data));
  } catch (err) {
    // TODO
  }
}

export function* updateMessage({ id }) {
  try {
    yield call(apiChat.put, "message", { id });
  } catch (err) {
    // TODO
  }
}

export function* getPendingMessages({ id_from, id_to, customer_key }) {
  try {
    const response = yield call(
      apiChat.get,
      `pending?id_from=${id_from}&&id_to=${id_to}&&customer_key=${customer_key}`
    );
    yield put(MessagesActions.getPendingMessagesSuccess(response.data));
  } catch (err) {
    // TODO
  }
}


// WEBPACK FOOTER //
// ./src/storeChat/sagas/messages.js